import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { durationString } from 'library/time';
import { formatActivities } from 'selectors/activity.selectors';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Tag } from 'antd';

const config = {
  activity: {
    format: formatActivities,
    reducer: REDUCER_KEY.activityList,
    filtering: {
      key: 'activityCollectionValues',
      placeholder: 'activity details',
      theme: 'activity'
    },
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '220px',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => (
          <div>
            <span className="bhp-indicator" style={{ backgroundColor: record.color }}>
              <span className="bhp-checkmark" />
            </span>
            <span>
              {`${record.name} ${record.activity_type.code ? `(${record.activity_type.code})` : ''}`}
            </span>
            <span>{!record.active && (<Tag color="red">Inactive</Tag>)}</span>
          </div>
        )
      },
      {
        title: 'Duration',
        dataIndex: 'duration',
        width: '100px',
        align: 'center',
        sorter: true,
        render: (text, record) => (
          <div>
            <span>
              {durationString(record.duration)}
            </span>
          </div>
        )
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '140px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [{
          text: 'Yes',
          value: true
        }, {
          text: 'No',
          value: false
        }],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    scroll: {
      x: 550,
      y: '100%'
    },
    showInlinePin: true,
    isRecordPinnable: () => true,
  },
  template: {
    reducer: REDUCER_KEY.templates,
    filtering: {
      key: 'templateCollectionValues',
      placeholder: 'template details',
      theme: 'template'
    },
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => (
          <div>
            <span className="bhp-indicator" style={{ backgroundColor: record.color }}>
              <span className="bhp-checkmark" />
            </span>
            <span>
              {record.name}
            </span>
          </div>
        )
      }
    ],
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    }
  },
  rosterBuilder: {
    reducer: REDUCER_KEY.rosterBuilders,
    filtering: {
      key: 'rosterBuilderCollectionValues',
      placeholder: 'roster builder details',
      theme: 'rosterbuilder'
    },
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => (
          <div>
            <span className="bhp-indicator" style={{ backgroundColor: record.color }}>
              <span className="bhp-checkmark" />
            </span>
            <span>
              {record.name}
            </span>
          </div>
        )
      }
    ],
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    }
  }
};

export default config;
